<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>集計表示一覧</template>
      <template v-slot:annotation
        >評価が完了している年度について、評価の集計を表示することができます</template
      >
    </PageHeader>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="集計は見つかりませんでした。新規追加ボタンより集計を設定してください。"
        >
          <template v-slot:[`item.BUTTON`]="{ item }">
            <Button
              v-if="item.PERIOD_STATUS == '3'"
              color="secondary"
              class="mr-1"
              @click="onClickSumDetail(item)"
              :small="true"
              >詳細</Button
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <DialogMessage ref="dialog" />
  </v-container>
</template>

<script>
import config from '@/const.js';
import axios from 'axios';
import message from '@/message.js';
import { getSessionStorageItem, makeDateFormatStr } from '@/common.js';
export default {
  name: 'SumList',
  components: {},

  data() {
    return {
      crumbs: [
        {
          name: '集計表示一覧',
          route: 'SumList',
        },
      ],

      loading: false,
      confirm: false,

      userInfo: {},

      searchForm: {},

      items: [],

      headers: [
        {
          text: '年度(期間)名称',
          value: 'PERIOD_NAME',
        },
        {
          text: '開始日',
          value: 'START_DATE',
        },
        {
          text: '終了日',
          value: 'END_DATE',
        },
        {
          text: '年度の状態',
          align: 'left',
          value: 'STATUS',
        },
        {
          text: '',
          align: 'left',
          value: 'BUTTON',
        },
      ],
    };
  },

  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;
    this.getPeriod();
  },

  methods: {
    onClickSumDetail(item) {
      this.$router.push({
        name: 'SumDetail',
        params: {
          periodId: Buffer.from(item.PERIOD_ID).toString('base64'),
          periodName: Buffer.from(item.PERIOD_NAME).toString('base64'),
        },
      });
    },
    async getPeriod() {
      this.loading = true;
      let vm = this;
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/period/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 年度データ取得
          vm.items = response.data;
          for (var i = 0; i < vm.items.length; i++) {
            // 開始年月
            vm.items[i].START_DATE = makeDateFormatStr(
              vm.items[i].PERIOD_START_DATE,
              '/',
              '/',
              ''
            );
            // 終了年月
            vm.items[i].END_DATE = makeDateFormatStr(
              vm.items[i].PERIOD_END_DATE,
              '/',
              '/',
              ''
            );
            // 年度の状態
            if (vm.items[i].PERIOD_STATUS == config.PERIOD_STATUS_BEFORE_GOAL) {
              // 目標作成前
              vm.items[i].STATUS = config.PERIOD_STATUS_BEFORE_GOAL_STR;
            } else if (
              vm.items[i].PERIOD_STATUS == config.PERIOD_STATUS_MAKE_GOAL
            ) {
              // 目標作成
              vm.items[i].STATUS = config.PERIOD_STATUS_MAKE_GOAL_STR;
            } else if (
              vm.items[i].PERIOD_STATUS == config.PERIOD_STATUS_EVAL_DURING
            ) {
              // 評価中
              vm.items[i].STATUS = config.PERIOD_STATUS_EVAL_DURING_STR;
            } else if (
              vm.items[i].PERIOD_STATUS == config.PERIOD_STATUS_EVAL_COMPLETE
            ) {
              // 評価確定
              vm.items[i].STATUS = config.PERIOD_STATUS_EVAL_COMPLETE_STR;
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.loading = false;
    },
  },
};
</script>
